import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { ReactComponent as Add } from '../../res/add.svg';
import ButtonWithIcon from '../../components/ButtonWithIcon';
import PopupTimeline from '../../components/PopupTimeline';

import styles from './styles';

class B24covidimpact extends React.Component {
  renderBackground() {
    const { classes } = this.props;
    return (
      <div className={classes.background}>
        <div className={classes.bgImg}></div>
        <div className={classes.greyCurve}></div>
      </div>
    );
  }

  renderContent() {
    const { classes, data, onPopup } = this.props;

    return (
      <div className={classes.content}>
        <div className={classes.desc}>
          <div className={classes.text}>
            <Typography variant="h6" className={classes.mainTitle}>
              {parse(data.blocks.b24covidimpact.mainTitle)}
            </Typography>
            <Typography variant="body1">{parse(data.blocks.b24covidimpact.desc)}</Typography>
          </div>
        </div>
        <div className={classes.aside}>
          <div className={classes.btn}>
            <ButtonWithIcon color="white" icon={<Add />} onClick={() => onPopup('popupTexts', true)}>
              {parse(data.blocks.b24covidimpact.textBtn)}
            </ButtonWithIcon>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { classes, data, popupsState, onPopup } = this.props;
    return (
      <div className={classes.blockContainer}>
        {this.renderBackground()}
        {this.renderContent()}
        <PopupTimeline
          color="green"
          timelinePopupData={data.popup.texts}
          open={!!popupsState.popupTexts}
          onClose={() => onPopup('popupTexts', false)}
        ></PopupTimeline>
      </div>
    );
  }
}

B24covidimpact.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
  popupsState: PropTypes.object,
  onPopup: PropTypes.func,
};

export default withStyles(styles)(B24covidimpact);
